import React from 'react';
import { mechanics } from '../../contanst/pro_customer';
import '../../assets/css/product/customer.css'

const Mechanics = () => {
    return (
        <div className='pro_customer_Exhibition1'>
            {
                mechanics.map((item, index) => {
                    return (
                        <div key={index}  >
                            <img src={item.pic} className='customer_img' />
                        </div>
                    )
                })
            }
        </div>
    ); 
}

export default Mechanics;
